<template>
  <div>
    <div class="sub-title">{{name}}</div>
    <div class="card-columns pb-4">
      <div class="card service-area-card" v-for="(serviceArea, index) in serviceAreas" :key="index">
        <div class="card-body service-area-card-body">
          <div class="card-title service-area">{{serviceArea.name}}</div>
          <div
            class="service"
            v-for="(service, index) in serviceArea.services"
            :key="index"
          >
            <a class="card-text service cursor-pointer" @click="handleClickServiceModal(service)">{{service.name}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    serviceAreas: Array
  },
  methods: {
    handleClickServiceModal(service) {
      this.$emit("handleClickServiceModal", service);
    },
  }
};
</script>

<style scoped>
.sub-title {
  font-size: 26px !important;
  color: #000000;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  font-family: artifaktElementBold !important;
}
.service-area-card {
  border: 0;
}

.service-area-card-body {
  padding: 15px 5px 1px 0px;
}
.service-area {
  font-size: 20px;
  color: #2f3642;
  font-weight: bold;
  line-height: 20px;
  font-family: artifaktElementBold !important;
}
.service a {
  font-weight: 200;
  font-size: 16px;
  color: #2f3642;
  line-height: 20px;
  cursor: pointer;
}
@media (max-width: 767px) {
 .service-area {
   font-size: 14px !important;
  }
  .sub-title {
    font-size: 16px !important;
  }
 .service a {
    margin-top: 14px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/service-directory/ServiceDirectoryPlatform.vue